import styled from 'styled-components';

export const Wrapper = styled.div`
  bottom: 0;
  left: 0;
  perspective: 100px;
  position: absolute;
  right: 0;
  top: 0;
`;



// WEBPACK FOOTER //
// ./src/components/IntroCloudItems/style.js